export default __webpack_public_path__ + "static/media/cat7-3.aa7e0c6b.jpg";